import React from 'react';

//interface
import { ICheckboxPanelItem } from  '@/interfaces/checkboxPanel';

//styling
import "../../../../css/global/Dropdown/CheckboxPanel.scss";



const CheckboxPanel = ({panelTitle, items} : {panelTitle: string, items: ICheckboxPanelItem[]}) => {

    return (
       <div className='checkbox-panel-container'>
            <span className='panel-title'>{panelTitle}</span>

            {items.map((item) => (
                <div key={item.id} className="check-box-item">
                    <input type='checkbox' id={`checkbox-panel-checkbox-${item.id}`} checked={item.isSelected} onChange={() => item.onCheck(item.id)} />
                    <label htmlFor={`checkbox-panel-checkbox-${item.id}`}>{item.content}</label>
                </div>
            ))}
       </div>
    )
}

export default CheckboxPanel